export const DOCUMENT_OWNER_OPTIONS = [
  { value: "other", label: "General shop documents" },
  { value: "customer", label: "Customer (by reference)" },
  { value: "quote", label: "Quote (by reference)" },
  { value: "job", label: "Job (by reference)" },
  { value: "purchase_order", label: "Purchase order (by reference)" },
  { value: "invoice", label: "Invoice (by reference)" },
];
